// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 537) return "js/537-6dfe691041e36fef9811.js";
	if (chunkId === 677) return "js/677-07d6eb9af24c9baa3483.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"45":"442e98f3b84b5a32eee5","240":"eed6695327d407eafb43"}[chunkId] + ".chunk.js";
};